var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.218 29.798l-4.93-4.92a15 15 0 10-1.41 1.41l4.92 4.93a.998.998 0 001.42 0 .997.997 0 00.219-1.094.998.998 0 00-.219-.326zm-16.21-1.79a13 13 0 110-26 13 13 0 010 26z"
  })));
}

export default SvgSearch;